import React, { Fragment } from 'react';
import cx from 'classnames';
import { Icons } from '../../Icons';
export const getCategoryButton = (categoryName, selectedItems, iconCategories, isCategoryNameRequired, theme) => {
    let buttonName = React.createElement("span", { className: "filter_button--category" }, categoryName);
    const selectedItemLength = selectedItems.length;
    if (selectedItemLength === 0) {
        return buttonName;
    }
    const [firstItem] = selectedItems;
    const useIcon = iconCategories && iconCategories.findIndex(category => category === categoryName) !== -1;
    if (firstItem.icon && useIcon) {
        const sortAlphabetically = (first, second) => {
            if (first.key > second.key) {
                return 1;
            }
            else if (first.key < second.key) {
                return -1;
            }
            return 0;
        };
        buttonName = (React.createElement(React.Fragment, null,
            isCategoryNameRequired && (React.createElement("span", { className: "filter_button--category" },
                categoryName,
                ": ")),
            React.createElement("span", { className: "filter_button--items" }, selectedItems.sort(sortAlphabetically).map(item => {
                const icon = (React.createElement(Icons, { iconName: `ic-${item.icon}`, title: item.icon, className: cx(item.icon, item.className), size: 24, style: theme && {
                        fill: theme[item.label.toLowerCase()],
                        color: theme[item.label.toLowerCase()],
                    } }));
                return React.createElement(Fragment, { key: item.key }, icon);
            }))));
    }
    else {
        if (selectedItemLength >= 1) {
            buttonName = (React.createElement(React.Fragment, null,
                isCategoryNameRequired && (React.createElement("span", { className: cx('filter_button--category', 'filter_button--textonly') },
                    categoryName,
                    ":")),
                React.createElement("span", { className: "filter_button--items" },
                    firstItem.label,
                    " ",
                    selectedItemLength > 1 && `(+${selectedItemLength - 1})`)));
        }
    }
    return buttonName;
};
export const getNewSelectedItems = (item, selectedItems, type) => {
    if (type === 'single') {
        return getItemsSingle(item, selectedItems);
    }
    return getItemsMulti(item, selectedItems);
};
const getItemsSingle = (item, selectedItems) => {
    // In a single select, there will only be one element in the array at max,
    // so check the keys directly
    if (selectedItems.length === 0 || selectedItems[0].key !== item.key) {
        return [item];
    }
    return [];
};
const getItemsMulti = (item, selectedItems) => {
    const indexOfItem = selectedItems.findIndex(({ key }) => key === item.key);
    if (indexOfItem === -1) {
        return [...selectedItems, item];
    }
    return [...selectedItems.slice(0, indexOfItem), ...selectedItems.slice(indexOfItem + 1)];
};
//# sourceMappingURL=helper.js.map